import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { SectionTab } from 'polotno/side-panel';
import MdPhotoLibrary from '@meronex/icons/md/MdPhotoLibrary';
import { ImagesGrid } from 'polotno/side-panel/images-grid';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { loginUser, logoutUser, language } from "./Redux/authAction";
import { searchByHeader, loginModal } from "./Redux/authAction";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import "./components/Styles.css";
import Goo from "./assets/icons/Picture1.png";
import login from "./assets/home/gmail.jpg";
import { auth } from "./FirebaseConfig";
import { loginDeveloper } from './Redux/authAction';
import {
  signInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  updateProfile,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import apiConfig from './config/api.js';

export const TemplatesPanel = observer(({ store }) => {
  const { category: paramCategory } = useParams();
  const [category, setCategory] = useState(paramCategory || 'all');
  const [dbData, setDbData] = useState([]);
  const [isDbLoading, setIsDbLoading] = useState(true);
  const [searchData, setSearchData] = useState([]);
  const [searchLoading, setSearchLoading] = useState(true);

  const displayName = useSelector((state) => state.authReducer.displayName); // Moved outside
  // const email = useSelector((state) => state.authReducer.email); // Moved outside
  const uid = useSelector((state) => state.authReducer.uid); // Moved outside
  const packageid = useSelector((state) => state.authReducer.packageid); // Moved outside
  const status = useSelector((state) => state.authReducer.status); // Moved outside
  const prevtemp_pkgid = useSelector((state) => state.authReducer.temp_pkgid); // Moved outside
  const useremail  = useSelector((state) => state.authReducer.email);

  console.log("Previous template: ",prevtemp_pkgid);

  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  console.log("AUthenticated",isAuthenticated);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [errorMessage, setErrorMessage] = useState("");

  const [name, setName] = useState("");
  const [emaill, setEmaill] = useState("");
  const [password, setPassword] = useState("");
  const [logEmail, setLogEmail] = useState("");
  const [logName, setLogName] = useState("");
  const [logPassword, setLogPassword] = useState("");
  const [openModel, setOpenModel] = useState(isAuthenticated ? false : true);
  const [google, setGoogle] = useState(null);
  const [categories, setCategories] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (result) => {
      if (result) {
        const { displayName, email } = result;
      } else {
      }
    });
    return () => unsubscribe();
  }, []);

  const isLang = useSelector((state) => state.authReducer.lang);
  const userID = useSelector((state) => state.authReducer.uid);
  const userName = useSelector((state) => state.authReducer.name);
  const emails = useSelector((state) => state.authReducer.email);
  const developeruid = useSelector((state) => state.authReducer.developeruid);
  const loginModalValue = useSelector((state) => state.authReducer.loginModal);
  console.log("Login modal value:",loginModalValue);
  useEffect(()=>{
    if(isAuthenticated === true){
      dispatch(loginModal(false));
    }
  })

  const handleOpen = () => {
    dispatch(loginModal(true));
    setOpenModel(true);
  };

  

  const handleClose = () => {
    dispatch(loginModal(false));
    dispatch(loginModal(false));
  };

 
  useEffect(() => {
    const handleReload = () => {
      if (performance.navigation.type === 1) {
        isAuthenticated
          ? dispatch(loginModal(true))
          : dispatch(loginModal(true));
      }
    };
    window.addEventListener("load", handleReload);
    return () => {
      window.removeEventListener("load", handleReload);
    };
  }, []);

  

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarOpen(false);
  };

  useEffect(() => {
    auth.onAuthStateChanged((user) => {});
  }, []);

  //----------------new data started---------------------
  const handlePasswordReset = async (auth, emaill) => {
    console.log("The Email is   :" + emaill);
    try {
      if (!emaill) {
        setSnackbarSeverity("error");
        setSnackbarMessage("Please enter a valid email address.");
        setSnackbarOpen(true);
        return;
      }

      await sendPasswordResetEmail(auth, emaill);
      setSnackbarSeverity("success");
      setSnackbarMessage(`Password reset email sent to ${emaill}. Please check your inbox.`);
      setSnackbarOpen(true);
    } catch (error) {
      let errorMessage = "An error occurred.";
      if (error.code === "auth/user-not-found") {
        errorMessage = "No user found with this email.";
      } else if (error.code === "auth/invalid-email") {
        errorMessage = "Invalid email address.";
      }
      setSnackbarSeverity("error");
      setSnackbarMessage(errorMessage);
      setSnackbarOpen(true);
    }
  };


  const handleSignup = async () => {
    try {
      if (name && emaill && password) {
        // Create user with email and password
        const userCredential = await createUserWithEmailAndPassword(auth, emaill, password);
        const user = userCredential.user;
        
        // Update user profile with display name
        await updateProfile(user, { displayName: name });
        
        // Send email verification
        await sendEmailVerification(user);
  
        setSnackbarSeverity("success");
        setSnackbarMessage("Signup successful! A verification email has been sent.");
        setSnackbarOpen(true);
  
        handleCloseModel();
      } else {
        setSnackbarSeverity("error");
        setSnackbarMessage("Please enter a valid name, email, and password.");
        setSnackbarOpen(true);
      }
    } catch (error) {
      let errorMessage = "Unexpected error occurred.";
      if (error.code === "auth/email-already-in-use") {
        errorMessage = "The email address is already in use.";
      } else if (error.code === "auth/invalid-email") {
        errorMessage = "The email address is not valid.";
      } else if (error.code === "auth/weak-password") {
        errorMessage = "The password is too weak.";
      }
      setSnackbarSeverity("error");
      setSnackbarMessage(errorMessage);
      setSnackbarOpen(true);
    }
  };
  
  
  const handleLogin = async () => {
   
    try {
      if (emaill && password) {
        // Sign in with email and password
        const userCredential = await signInWithEmailAndPassword(auth, emaill, password);
        const user = userCredential.user;
        const { displayName, email, uid } = user; // Fix: Renamed email_ back to email
        console.log("The display name is  :" + displayName);
        console.log("The email is  :" + email); // Fix: Correct variable name
        console.log("The UID is  :" + uid);
        
        // Send UID to fetch subscription data
        const formData = new FormData();
        formData.append("uid", uid);
  
        const response = await fetch(`${apiConfig.API_URL}/aapi/getsubscriptiondata.php`, {
          method: "POST",
          body: formData,
        });
  
        if (!response.ok) {
          throw new Error("Failed to fetch subscription data.");
        }
  
        const data = await response.json();
  
        if (data.status === "success" && data.data.length > 0) {
          const subscription = data.data[0]; // Get the first subscription record
          const { packageid, status } = subscription;
  
          // Dispatch login details to Redux
          dispatch(loginUser({ displayName, email, uid, packageid, status })); // Fix: Using 'email' here
  
          console.log("The ID from redux name is  ------------------------ >  :" + packageidid);
          console.log("The UID from redux name is  ------------------------ >  :" + uid);
          // Show success snackbar
          setSnackbarSeverity("success");
          setSnackbarMessage(isLang === "arabic" ? "تسجيل الدخول بنجاح!" : "Login successful!");
          setSnackbarOpen(true);
  
          // Close login modal
          dispatch(loginModal(false));
          handleCloseModel();
        } else {
          // If no subscription found, show an error
          setSnackbarSeverity("error");
          setSnackbarMessage(isLang === "arabic" ? "لم يتم العثور على اشتراك." : "No subscription found.");
  
          const subscription = data.data[0]; // Get the first subscription record
          const { packageid, status } = subscription;
          dispatch(loginUser({ displayName, email, uid, packageid, status })); // Fix: Using 'email' here
  
          console.log("The ID from redux name is  ------------in case of no data------------ >  :" + packageidid);
          setSnackbarOpen(true);
          handleCloseModel();
        }
      } else {
        // If email or password is missing, show an error
        setSnackbarSeverity("error");
        setSnackbarMessage(isLang === "arabic" ? "يرجى إدخال البريد الإلكتروني وكلمة المرور." : "Please enter both email and password.");
        setSnackbarOpen(true);
        handleCloseModel();
      }
    } catch (error) {
      console.error("Login Error:", error.message);
  
      // Show error snackbar
      setSnackbarSeverity("error");
      setSnackbarMessage(isLang === "arabic" ? "فشل تسجيل الدخول. تحقق من بياناتك." : "Failed to login. Please check your credentials.");
      setSnackbarOpen(true);
      handleCloseModel();
    }
  };
  const handleDesignerSignup = async () => {
    try {
      if (name && emaill && password ) {

        const loginData = new FormData();
        loginData.append("username", emaill);
        loginData.append("password", password);
        loginData.append("fullname", name);
        loginData.append("role","Designer");

        try {

          const response = await fetch(`${apiConfig.API_URL}/aapi/developer_api/register.php`, {
            method: "POST",
            body: loginData, // Send FormData object instead of JSON
          });
    
          if (!response.ok) {
            throw new Error("Login failed, please try again.");
          }
        } catch(error){
          console.error("Signup :", error.message);
          // Show error snackbar
          setSnackbarSeverity("error");
          setSnackbarMessage("Failed to SignUp. Please check your credentials.");
          setSnackbarOpen(true);
          handleCloseModel();
        }
        try{
          
          const emaildata = new FormData();
          emaildata.append("to",emaill);
          emaildata.append("subject","Account Verification");
          // Generate the verification URL
const verificationUrl = `${apiConfig.API_URL}/aapi/developer_api/developeremailverification.php?email=${encodeURIComponent(emaill)}`;

// Create an HTML email with a button
const emailContent = `
  <html>
    <body>
      <p>Thank you for signing up! Please click the button below to verify your account:</p>
      <a href="${verificationUrl}" style="
        display: inline-block;
        padding: 10px 20px;
        font-size: 16px;
        color: white;
        background-color: #4c76cf;
        text-decoration: none;
        border-radius: 5px;
      ">Verify Email</a>
      <p>If you did not sign up, you can ignore this email.</p>
    </body>
  </html>
`;

// Append the HTML content to your email data
emaildata.append("message", emailContent);

          const response = await fetch(`${apiConfig.API_URL}/aapi/desingersendemail.php`, {
            method: "POST",
            body: emaildata, // Send FormData object instead of JSON
          });

          if (!response.ok) {
            throw new Error("Failed to send email!.");
          }

        }
        catch(error){
          setSnackbarSeverity("error");
          setSnackbarMessage(errorMessage);
          setSnackbarOpen(true);

        }
        setSnackbarSeverity("success");
        setSnackbarMessage("Signup successfull! Verification Email has been sent!");
        setSnackbarOpen(true);
  
        handleCloseModel();
      } else {
        setSnackbarSeverity("error");
        setSnackbarMessage("Please enter a valid name, email, and password.");
        setSnackbarOpen(true);
      }
    } catch (error) {
      let errorMessage = "Unexpected error occurred.";
      if (error.code === "auth/email-already-in-use") {
        errorMessage = "The email address is already in use.";
      } else if (error.code === "auth/invalid-email") {
        errorMessage = "The email address is not valid.";
      } else if (error.code === "auth/weak-password") {
        errorMessage = "The password is too weak.";
      }
      setSnackbarSeverity("error");
      setSnackbarMessage(errorMessage);
      setSnackbarOpen(true);
    }
  };
  

  const handleDesignerLogin = async (e) => {
    e.preventDefault();

    // Create a FormData object and append the email and password
    const loginData = new FormData();
    loginData.append("username", emaill);
    loginData.append("password", password);

    try {
      const response = await fetch(`${apiConfig.API_URL}/aapi/developer_api/login.php`, {
        method: "POST",
        body: loginData, // Send FormData object instead of JSON
      });

      if (!response.ok) {
        throw new Error("Login failed, please try again.");
      }

      const result = await response.json();
      const data = result.data;
      console.log("----data----",data);
      const developername = data.fullname;
      const developeremail = data.username;
      const developerrole = data.role;
      const developeruid = data.id;
      dispatch(loginDeveloper({developername, developeremail,developerrole , developeruid}));

      // If login is successful, update local state and close modal
      if (result.status === "success") {
        setErrorMessage("Login successful!"); // Display success message
        // alert("User logged is as desinger");
        setTimeout(() => {
          setIsLoggedIn(true); // Set logged in state to true
          setIsModalOpen(false); // Close modal after success message is displayed
          setErrorMessage(""); // Clear the error message
          
        }, 1500); // Delay modal closing by 1.5 seconds
        navigate("/Templates");
      } else {
        setErrorMessage(result.message || "Login failed. Invalid credentials.");
      }
    } catch (error) {
      setErrorMessage(error.message || "An error occurred. Please try again.");
    }
  };
  const [openDesignerLoginModal, setOpenDesignerLoginModal] = useState(false);
const handleOpenDesignerLogin = () => setOpenDesignerLoginModal(true);
const handleCloseDesignerLogin = () => setOpenDesignerLoginModal(false);

const [openDesignerSignupModal, setOpenDesignerSignupModal] = useState(false);
const handleOpenDesignerSignup = () => setOpenDesignerSignupModal(true);
const handleCloseDesignerSignup = () => setOpenDesignerSignupModal(false);
  

  const handelOpenModel = () => {
    dispatch(loginModal(false))
    setOpenModel(true);
  };
  const handleClose2 = () => {
    dispatch(loginModal(false)) 
    dispatch(loginModal(false))
  };



  const handleCloseModel = () => setOpenModel(false);
  

  

  const handleGoogleLogin = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        const { displayName, email, uid } = user;
        
        dispatch(loginUser({ displayName, email, uid }));
        dispatch(loginModal(false));
        window.location.href = "/category/design/Promotion Maker";
      })
      .catch((error) => {
        console.error("Google Login Error:", error.message);
      });
  };

  //------------------new data ended------------------

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response;
  
        if (category === "all" || !isNaN(category))  {
          response = await axios.get(`${apiConfig.API_URL}/aapi/api.php`);
        } else {
          response = await axios.get(`${apiConfig.API_URL}/aapi/tempbycat.php?title=${category}`);
        }
  
        setDbData(response.data);
        handleOpen();
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsDbLoading(false);
      }
    };
  
    // Fetch data when the component mounts
    fetchData();
  }, [category]);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiConfig.API_URL}/aapi/api.php`);
        const uniqueTitlesSet = new Set();
        const uniqueData = response.data.filter((item) => {
          if (!uniqueTitlesSet.has(item.title)) {
            uniqueTitlesSet.add(item.title);
            return true;
          }
          return false;
        });
        const mappedData = uniqueData.map((item) => ({ label: item.title }));
        setSearchData(mappedData);
        handleOpen();
      } catch (error) {
        console.error('Error fetching search data:', error);
      } finally {
        setSearchLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleAutocompleteChange = (event, newValue) => {
    setCategory(newValue?.label || 'all');
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "clamp(750px,100%,300px)",
    height: "600px",
    bgcolor: "background.paper",
    border: "0px solid #000",
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <div style={{ height: '100%' }}>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={searchData}
          loading={searchLoading}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField {...params} label="Category" />
          )}
          onChange={handleAutocompleteChange}
        />

        <ImagesGrid
          shadowEnabled={false}
          isLoading={isDbLoading}
          images={dbData?.map((data) => data).flat()}
          getPreview={(item) => {
            const matchingItem = dbData.find((dbItem) => dbItem.id === item.id);
            // console.log(matchingItem);
            return matchingItem ? `${apiConfig.API_URL}/aapi/templetes/${matchingItem.imagepath}` : '';
          }}
          onSelect={async (item) => {
            console.log("Templete cliecked here _____________________________________",item.pkgid)
            const temp_pkgid = item.pkgid;
            const temp_id = item.id;
            console.log(displayName,uid,packageid, status,temp_pkgid, "templateid:",temp_id);
            if (uid !== null) { 
              dispatch(loginUser({ displayName, uid, email:useremail, packageid, status, temp_pkgid,temp_id }));
            }
            console.log("temp package id: ", temp_pkgid);
            console.log("clicked template: ",prevtemp_pkgid);

            const selectedDbItem = dbData.find((dbItem) => dbItem.id === item.id);
            if (selectedDbItem) {
              if (selectedDbItem.category == 50) {
                navigate(`/pages/specificbuilder/${selectedDbItem.templetepath}`);
              } else if (selectedDbItem.category == 52) {
                navigate(`/CoverBuilder/${selectedDbItem.templetepath}`);
              } else {
                const req = await fetch(`${apiConfig.API_URL}/aapi/templetes/${selectedDbItem.templetepath}`);
                const json = await req.json();
                store.loadJSON(json);
              }
            }
          }}
          mber={2}
        />
      </div>

      <Modal
  open={loginModalValue}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style} className="rounded-lg text-[#262b33]">
    <div className="flex">
      <div className="w-[50%] h-[70vh] flex flex-col gap-4 mr-7 ml-2">
        <p className="mb-[30px] mt-[20px] text-[28px] font-[700] relative -left-3">Welcome back!!</p>
        <div>
          <p>Email:</p>
          <input
            type="text"
            placeholder="Email"
            value={emaill}
            onChange={(e) => setEmaill(e.target.value)}
            className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
          />
        </div>
        <div>
          <p>Password</p>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
          />
        </div>
        <div onClick={() => handlePasswordReset(auth, emaill)} className="w-full flex justify-end items-center">
          <span>Forget Password?</span>
        </div>
        <button
          onClick={handleLogin}
          className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8] px-7 py-3 rounded-md text-white text-[16px] font-[600] cursor-pointer"
        >
          Login
        </button>
        <button
          onClick={handleGoogleLogin}
          className="flex items-center bg-white dark:bg-gray-900 border border-gray-300 rounded-lg shadow-md px-6 py-2 text-sm font-medium text-gray-800 dark:text-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          <img src={Goo} className="h-8" alt="Google Logo" />
          <span>Continue with Google</span>
        </button>
        <div style={{ display: "flex", gap: "4px" }}>
          <p>Do Not Have an Account: </p>{" "}
          <button onClick={handelOpenModel} className="focus:outline-none active:outline-none text-[#3b603d] font-[600] hover:underline">
            Sign Up
          </button>
        </div>

        <div style={{display:"flex", gap:"4px"}}>
          Are you a 
        <button 
        onClick={() => {
          handleClose(); // Close Signup Modal
          handleOpenDesignerLogin(); // Open Login Modal
        }}
        className="focus:outline-none active:outline-none text-[#3b603d] font-[600] hover:underline">
  Designer?
</button>

        </div>
      </div>
      <div className="w-[50%] h-[100%] bg-slate-600 overflow-hidden">
        <img src={`${login}`} className="h-full" alt="" />
      </div>
    </div>
  </Box>
</Modal>

<Modal
  open={openDesignerSignupModal}
  onClose={handleCloseDesignerSignup}
  aria-labelledby="designer-signup-modal-title"
  aria-describedby="designer-signup-modal-description"
>
  <Box sx={style} className="rounded-lg text-[#262b33]">
    <div className="flex">
      {/* Image on the left */}
      <div className="w-[50%] h-[100%] bg-slate-600 overflow-hidden">
        <img src={`${login}`} className="h-full" alt="" />
      </div>
      <div className="w-[50%] h-[70vh] flex flex-col gap-4 mr-7 ml-2 pl-4">
        <p className="mb-[30px] mt-[20px] text-[28px] font-[700] relative ">Designer Signup</p>
        <div>
          <label>Name:</label>
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full h-9 bg-white focus:outline-none pl-2"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
              borderRadius: "5px",
              border: "1px solid #63626240",
            }}
          />
        </div>
        <div>
          <label>Email:</label>
          <input
            type="text"
            placeholder="Email"
            value={emaill}
            onChange={(e) => setEmaill(e.target.value)}
            className="w-full h-9 bg-white focus:outline-none pl-2"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
              borderRadius: "5px",
              border: "1px solid #63626240",
            }}
          />
        </div>
        <div>
          <label>Password:</label>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full h-9 bg-white focus:outline-none pl-2"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
              borderRadius: "5px",
              border: "1px solid #63626240",
            }}
          />
        </div>
        <button onClick={handleDesignerSignup} className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8] py-2 rounded-md text-white text-[16px] font-[600] cursor-pointer">
          Signup
        </button>
        <button
          onClick={handleGoogleLogin}
          className="flex items-center bg-white dark:bg-gray-900 border border-gray-300 rounded-lg shadow-md px-4 py-[6px] text-sm font-medium text-gray-800 dark:text-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          <img src={Goo} className="h-8" alt="Google Logo" />
          <span>Continue with Google</span>
        </button>

        <div className="flex gap-1">
          <p>Already Have an Account?</p>
          <button
            onClick={() => {
              handleCloseDesignerSignup(); // Close Signup Modal
              handleOpenDesignerLogin(); // Open Login Modal
            }}
            className="focus:outline-none active:outline-none text-[#3b603d] font-[600] hover:underline"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  </Box>
</Modal>

<Modal
  open={openDesignerLoginModal}
  onClose={handleCloseDesignerLogin}
  aria-labelledby="designer-login-modal-title"
  aria-describedby="designer-login-modal-description"
>
  <Box sx={style} className="rounded-lg text-[#262b33]">
    <div className="flex">
      {/* Image on the left */}
      <div className="w-[50%] h-[100%] bg-slate-600 overflow-hidden">
        <img src="/herosection/desingerloginmodal.png" className="h-full" alt="" />
      </div>
      <div className="w-[50%] h-[70vh] flex flex-col gap-4 mr-7 ml-2 pl-4">
        <p className="mb-[30px] mt-[20px] text-[28px] font-[700] relative ">Designer Login</p>


        {errorMessage && <p className="text-red-500 mb-4">{errorMessage}</p>}

        <div>
          <p>Email:</p>
          <input
            type="text"
            placeholder="Email"
            value={emaill}
            onChange={(e) => setEmaill(e.target.value)}
            className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
          />
        </div>
        <div>
          <p>Password:</p>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
          />
        </div>
        <button
          onClick={handleDesignerLogin}
          className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8] px-7 py-3 rounded-md text-white text-[16px] font-[600] cursor-pointer"
        >
          Login
        </button>
        {/* <button
          onClick={handleGoogleLogin}
          className="flex items-center bg-white dark:bg-gray-900 border border-gray-300 rounded-lg shadow-md px-6 py-2 text-sm font-medium text-gray-800 dark:text-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          <img src={Goo} className="h-8" alt="Google Logo" />
          <span>Continue with Google</span>
        </button> */}
        <div className="flex gap-1">
          <p>Do Not Have an Account?</p>
          <button onClick={() => {
            handleOpenDesignerSignup();
            handleCloseDesignerLogin();
            handleClose(); 
          }}
          className="focus:outline-none active:outline-none text-[#3b603d] font-[600] hover:underline">
            Sign Up
          </button>
        </div>

        {/* Add the "User?" button here */}
        <div className="flex gap-1">
          <p>Are you a </p>
          <button
            onClick={() => {
              handleCloseDesignerLogin();
              handleOpen(); // Opens User Login Modal
            }}
            className="focus:outline-none active:outline-none text-[#3b603d] font-[600] hover:underline"
          >
            User?
          </button>
        </div>
      </div>
    </div>
  </Box>
</Modal>

    </>
  );
});

export const TemplatesSection = {
  name: 'custom-templates',
  Tab: (props) => (
    <SectionTab name="Maker4U" {...props}>
      <MdPhotoLibrary style={{ margin: 'auto', fontSize: '16px' }} />
    </SectionTab>
  ),
  Panel: TemplatesPanel,
};
